import { render } from "./PurchaseWidget.vue?vue&type=template&id=309d541f&scoped=true"
import script from "./PurchaseWidget.vue?vue&type=script&lang=js"
export * from "./PurchaseWidget.vue?vue&type=script&lang=js"

import "./PurchaseWidget.vue?vue&type=style&index=0&id=309d541f&scoped=true&lang=css"
import "@vueform/slider/themes/default.css?vue&type=style&index=1&lang=css"

import exportComponent from "/home/nils/assessment_tool/code/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-309d541f"]])

export default __exports__